/**
 * Hỗ trợ (Support) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const AssistedEntryPage = lazy(() =>
  import("@/features/workspaces/module-pages").then((mod) => ({ default: mod.AssistedEntryPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const assistedEntryRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ho-tro/phat-nguyen/nhap-ho",
  component: withSuspense(AssistedEntryPage),
});

export const hoTroRoutes = [
  assistedEntryRoute,
];
